import { FC } from "react"
import { useParams } from "react-router-dom"
import { UserbotPage } from "./userbotPage"
import { ChainReportResolver } from "../components/chains/chainReportResolver"

export const ChainReportResolverPage: FC = () => {
  const { id } = useParams<{ id: string }>()
  return (
    <UserbotPage title="Отчёт по цепочке">
      {id && <ChainReportResolver id={id} />}
    </UserbotPage>
  )
}
